module.exports = __webpack_public_path__ + "static/img/katakura_03.5450c0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/katakura_03.jpg
// module id = LQ3D
// module chunks = 0